import { render, staticRenderFns } from "./SecurityEventsPage.vue?vue&type=template&id=491523c0&"
import script from "./SecurityEventsPage.vue?vue&type=script&lang=js&"
export * from "./SecurityEventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports